import React, { Component } from 'react';
import Badge from 'react-bootstrap/Badge';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';

const INDEX_DATE = 0;
const INDEX_TIME = 1;

class CompanyIntel extends Component {
    render() {
        const { emails } = this.props;
        const email_sent_times = emails.map(email => ({
                                     x: email.sent_at.split('T')[INDEX_DATE],
                                     y: email.sent_at.split('T')[INDEX_TIME]
                                 }));
        const theme = {
            axis: {
                legend: {
                    text: {
                        fontSize: '16px',
                        // fill: '#a01d26',
                        fontWeight: 400
                    }
                }
            }
        };
        const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const time_zone_human_readable = time_zone.split('/').pop().replace('_', ' ');
        return (
            <div className="row justify-content-center">
                <div className="col-12 shadow bg-paper col-lg-9">
                    <h5>Send Times: </h5>
                    <ResponsiveScatterPlot
                        theme={theme}
                        colors={"#F47560"}
                        data={[{
                            id: "Emails Sent At",
                            data: email_sent_times
                        }]}
                        xScale={{
                            type: 'time',
                            format: '%Y-%m-%d',
                            precision: 'day',
                        }}
                        xFormat="time:%Y-%m-%d"
                        yScale={{
                            type: 'time',
                            format: '%H:%M:%S',
                            precision: 'second',
                            useUTC: false,
                            min: '00:00:00',
                            max: '24:00:00',
                        }}
                        yFormat="time:%H:%M:%S"
                        axisLeft={{
                            format: '%I %p',
                            legend: 'Time of Day (' + time_zone_human_readable + ')',
                            legendPosition: 'middle',
                            legendOffset: -70,
                        }}
                        axisBottom={{
                            format: '%b %d'
                        }}
                        margin={{
                            top: 24,
                            right: 24,
                            bottom: 80,
                            left: 90
                        }}
                        height={500}
                        legends={[
                            {
                                anchor: 'bottom-left',
                                direction: 'row',
                                translateY: 60,
                                itemWidth: 130,
                                itemHeight: 12,
                                symbolSize: 12,
                                symbolShape: 'circle',
                            },
                        ]}
                        tooltip={({ node: {
                                    data: { formattedX, formattedY },
                                    style: { color }
                                }}) => (
                                    <div
                                        style={{
                                            color: '#f4f4ef',
                                            background: '#20232a',
                                            padding: '12px 16px',
                                        }}
                                    >
                                        <strong>Email Sent At:</strong>
                                        <br />
                                        Date: { formattedX }
                                        <br />
                                        Time: { formattedY }
                                    </div>
                                )}
                    />
                </div>
            </div>
        );
    }
}

export default CompanyIntel;
